<!------------------------pay rate------------------------------------------------------------------>
<span id="modelopen" data-bs-toggle="modal" data-bs-target="#PayorRateedit"></span>
<div class="modal fade" id="PayorRateedit" data-bs-backdrop="static">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" *ngIf="!payrateevntchange.isEditPayorrate">Update
          Payrate</h5>
        <h5 class="modal-title font-header" *ngIf="payrateevntchange.isEditPayorrate"> New Payrate</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="back()"></button>
      </div>
      <div class="modal-body">
        <ng-container *ngFor="let val of payrateList;let i=index">
          <div class="row mb-5">
            <div class="col-4">
              <label class="label-bold">Client</label>
              <ng-select [items]="clientDropdown" bindValue="id" bindLabel="clientName" [(ngModel)]="val.clientId"
                [searchable]="true" [clearable]="true" [ngModelOptions]="{standalone: true}"
                >
              </ng-select>
            </div>
            <div class="col-4">
              <label class="label-bold">Start Date <sup class="super-script">&nbsp;*</sup></label>
              <my-date-picker [options]="myDatePickerOptions" [selDate]="val.startDate" placeholder="mm/dd/yyyy"
              (inputFieldChanged)="payRateStartDate(i,$event)"
              (dateChanged)="onDateChangedStartDate(i,$event)">
              </my-date-picker>
            </div>

            <div class="col-4">
              <label class="label-bold">End Date </label>
              <my-date-picker [options]="myDatePickerOptions" [selDate]="val.endDate" placeholder="mm/dd/yyyy"
                (inputFieldChanged)="payRateEndDate(i,$event)"
               (dateChanged)="onDateChangedEndDate(i,$event)">
               </my-date-picker>
            </div>
            <div class="col-4">
              <label class="label-bold">Service <sup class="super-script">&nbsp;*</sup></label>
              <ng-select [(ngModel)]="val.serviceId" [searchable]="true" [clearable]="true" (ngModelChange)="CheckTrans_Service(val.serviceId,i)"
                [items]="serviceList" bindLabel="Value" bindValue="Key" groupBy="type">
              </ng-select>
            </div>
            <div class="col-4">
              <label class="label-bold">Pay Rate <sup class="super-script">&nbsp;*</sup> </label>
              <input *ngIf="!isTransPortation_Service" type="number" min="0" placeholder="Pay rate in $" [(ngModel)]="val.rate" class="form-control"
                (keypress)="keyPressForDecimal($event)" />
                <input *ngIf="isTransPortation_Service" type="number" min="0" placeholder="Pay rate in $" [(ngModel)]="val.rate" class="form-control"
                (keypress)="numbersOnly($event)" />
                <!-- <input type="text" [formControl]="decimalFormControl" (keypress)="numbersOnly($event)" [(ngModel)]="val.rate"/> -->
            </div>
            <div class="col-4">
              <div class="d-flex mt-4 p-0">
                <button class="btn btn-sm btn-danger ms-3" title="Clear All" (click)="clearAll(i,val)">Clear
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm" style="text-transform:none; margin-right:5px;"
      [disabled]="isSaveorUpdateBoolean"    (click)="savePayRate(payrateList);" *ngIf="!payrateevntchange.isEditPayorrate">
          Save & Close</button>
        <button class="btn  btn-sm" style="text-transform:none; margin-right:5px;"
        [disabled]="isSaveorUpdateBoolean"    (click)="savePayRate(payrateList);" *ngIf="payrateevntchange.isEditPayorrate">
          Update & Close</button>
        <button type="button" class="btn btn-sm" (click)="back()" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!----------------------------------delete payrate----------------------------------------------------------------->
<span id="deletepayratemodal" data-bs-toggle="modal" data-bs-target="#deletepayrate"></span>
<div class="modal fade" id="deletepayrate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="back()"></button>
      </div>
      <div class="modal-body">
        Do you want to delete this record ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal" (click)="deletepayrae()">Yes</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal" (click)="back()">No</button>
      </div>
    </div>
  </div>
</div>




  
   
